import { useFormikContext } from 'formik';
import { OfferEligibility, OfferType } from 'legacy/events/types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaChevronRight } from 'react-icons/fa';
import classnames from 'classnames';
import styles from 'legacy/common/components/form/Form.module.scss';

interface ItemSelectionProps {
  eligibility: OfferEligibility;
  setItemSelectionModal: ({ id, show }: { id: string; show: boolean }) => void;
  index: number;
  placeholder: string;
}

const ItemSelection = ({
  eligibility,
  setItemSelectionModal,
  index,
  placeholder
}: ItemSelectionProps) => {
  const { t } = useTranslation(['events']);
  const { errors } = useFormikContext<OfferType>();
  const eligibleItemsCount = eligibility?.items?.length || 0;
  const selectedItemText = eligibility?.items
    ?.slice(0, 2)
    .map((item) => item.name)
    .join(', ');
  const remainingItemText =
    eligibleItemsCount - 2 > 0 ? `... +${eligibleItemsCount - 2} ${t('settings.promoterOffers.itemSelection.more')}` : '';
  const totalItemText =
    eligibleItemsCount > 0 ? `${selectedItemText} ${remainingItemText}` : '';

  return (
    <div>
      <div className="relative">
        <div
          className="cursor-pointer"
          onClick={() => {
            setItemSelectionModal({
              id: eligibility.id,
              show: true
            });
          }}
        >
          <input
            type="text"
            id="selectedItems"
            name="selectedItems"
            value={totalItemText}
            placeholder={placeholder}
            className={classnames(
              'w-full border-1 border-[#DCDCDC] px-4 py-2 mx-auto h-12 rounded-md mt-2',
              {
                [styles.errorField]:
                  errors?.eligibilityCriteria &&
                  errors?.eligibilityCriteria[index]
              }
            )}
            readOnly
          />
          <span
            className={classnames(
              'absolute right-3 top-1/2 transform -translate-y-1/4',
              {
                'top-1/3':
                  errors?.eligibilityCriteria &&
                  errors?.eligibilityCriteria[index]
              }
            )}
          >
            <FaChevronRight className="text-[#B1B1B1] h-4 w-4" />
          </span>
          {errors?.eligibilityCriteria &&
            errors?.eligibilityCriteria[index] && (
              <div className={classnames(styles.error)}>
                {(errors.eligibilityCriteria[index] as any)?.items}
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default ItemSelection;
